import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./draw-buffer-checkbox.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./draw-buffer-checkbox.scss?ngResource";
import { ChangeDetectionStrategy, Component, EventEmitter, Injectable, Output } from "@angular/core";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
export let DrawBufferCheckboxComponent = class DrawBufferCheckboxComponent {
    toggleBufferEvent = new EventEmitter();
    bufferLabel = "Add buffer";
    constructor() {
    }
    toggleBuffer(event) {
        const bufferTool = document.getElementById("bufferTool");
        if (event) {
            bufferTool.removeAttribute("hidden");
        }
        else {
            bufferTool.setAttribute("hidden", "");
        }
        this.toggleBufferEvent.emit(event);
    }
    addBufferCheckbox(mapView) {
        const checkBoxBuffer = document.getElementsByTagName("app-draw-buffer")[0];
        reactiveUtils.when(() => mapView?.ready === true, () => {
            const panel = document.querySelectorAll(".esri-sketch__panel");
            if (panel[0]) {
                panel[0].append(checkBoxBuffer);
            }
        });
    }
    static ctorParameters = () => [];
    static propDecorators = {
        toggleBufferEvent: [{ type: Output }]
    };
};
DrawBufferCheckboxComponent = __decorate([
    Component({
        selector: "app-draw-buffer",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    Injectable({
        providedIn: "root"
    })
], DrawBufferCheckboxComponent);
